import { SegmentedControl, SegmentedControlProps, rem } from '@mantine/core';
import cn from 'clsx';
import { Select } from 'src/components/Select/Select';

const maxWidthValues = ['sm', 'md', 'lg'];
const maxWidthClasses = maxWidthValues.reduce(
  (acc, width) => {
    acc[width] = {
      buttons: `max-${width}:hidden`,
      select: `${width}:hidden`,
    };
    return acc;
  },
  {} as Record<string, { buttons: string; select: string }>
);

export function FilterButtons({
  data,
  value,
  compact,
  selectMaxW = maxWidthValues[0],
  onChange,
  segControlProps,
}: {
  data: SegmentedControlProps['data'];
  value: SegmentedControlProps['value'];
  compact?: boolean;
  selectMaxW?: (typeof maxWidthValues)[number];
  onChange: SegmentedControlProps['onChange'];
  segControlProps?: Partial<SegmentedControlProps>;
}) {
  if (data.length <= 1) {
    return null;
  }

  return (
    <>
      <SegmentedControl
        withItemsBorders={false}
        {...segControlProps}
        data={data}
        value={value}
        onChange={onChange}
        styles={{
          root: {
            outline: 'none',
            background: 'transparent',
            gap: compact ? rem(8) : rem(16),
            height: compact ? rem(32) : rem(48),
            overflow: 'visible',
          },
          indicator: { display: 'none' },
        }}
        className={cn(maxWidthClasses[selectMaxW].buttons)}
        classNames={{
          label: cn(
            compact
              ? 'px-6 rounded-[8px] !leading-8 text-xs'
              : 'px-9 rounded-[100px] !leading-[3rem] text-sm',
            'outline-[1px] outline outline-white/[0.14]',
            'font-[700]',
            'transition-colors data-[active]:bg-primarypurple/10 data-[active]:outline-primarypurple hover:outline-primarypurple'
          ),
        }}
      />

      <Select
        options={data.map((o) =>
          typeof o === 'string'
            ? { label: o, value: o }
            : { label: o.label as string, value: o.value }
        )}
        value={value}
        stackProps={{
          className: cn(maxWidthClasses[selectMaxW].select),
        }}
        onChange={onChange}
      />
    </>
  );
}
